module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"User Settings","tab":{"users":"Web Users","roles":"Role Settings"},"comingSoon":"(coming soon)"}}')
  delete Component.options._Ctor
}
